import HorizontalScrollCarousel from "./HorizontalScrollCarousel";

export default HorizontalScrollCarousel;